import PropTypes from "prop-types";
import React from "react";

import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";

const AcceptResponseConfirmationMessage = ({ recognitionRecipient }) => (
    <li className="system-message warning message-accept-response-confirmation">
        <div className="icon icon-warning">
            <SvgIcon src={iconSprite} id="icon-exclamation" />
        </div>
        <p className="body">
            {i18n.t("rtm.text.accepting_answer", {
                recognitionRecipientName: recognitionRecipient.name,
            })}
        </p>
    </li>
);

AcceptResponseConfirmationMessage.propTypes = {
    recognitionRecipient: PropTypes.object.isRequired,
};

export default AcceptResponseConfirmationMessage;
